export default __webpack_public_path__ + "assets/webgl/plastic_BaseColor.91511b8d.jpg";